import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import {Observable} from 'rxjs';
import {tap} from 'rxjs/operators';

import { AppConfig, APP_CONFIG_TOKEN } from "libs/config/app.lib.config";
import {select, Store} from '@ngrx/store';
import {selectPatientIds} from '../store/patient.selectors';
import {PatientState } from '../store/patient.reducer';
import {AddPatient, UpsertPatient } from '../store/patient.actions';
import { PatientModel } from 'libs/tm-common/src/lib/models/patient.model';
import { deepTrim } from 'libs/tm-common/src/lib/utils/string.utils';

@Injectable({
	providedIn: 'root'
})
export class PatientsService {
	private httpClient = inject(HttpClient);
	private store = inject<Store<PatientState>>(Store);
	private config = inject<AppConfig>(APP_CONFIG_TOKEN);

	patientsIds: string[];

	constructor() {

		this.store.pipe(select(selectPatientIds))
			.subscribe(ids => this.patientsIds = ids.map(id => deepTrim(id)));
	}

	getPatients(): Observable<PatientModel[]> {
		return this.httpClient.get<PatientModel[]>(
			`${this.config.apiUrl}/patients`,
			{
				withCredentials: true
			}
		);
	}

	uniquePatientId(patientId) {
		return this.patientsIds.findIndex(id => id === patientId) === -1;
	}

	savePatient(patient): Observable<PatientModel> {
		return this.httpClient
			.post<PatientModel>(`${this.config.apiUrl}/patients`, patient , {withCredentials: true})
			.pipe(
				tap( newPatient => this.store.dispatch( new AddPatient({patient: newPatient})))
			);
	}

	updatePatient(patient: Partial<PatientModel>): Observable<PatientModel> {
		return this.httpClient
			.patch<PatientModel>(`${this.config.apiUrl}/patients/${patient._id}`, patient, {withCredentials: true})
			.pipe(
				tap( updatedPatient => this.store.dispatch( new UpsertPatient({patient: updatedPatient})))
			);
	}


}
